import {styled} from "@mui/system";
import {List} from "@mui/material";
import Colors from "../../../../../../general/constants/colors";

export const SubMenuItemsStyledLvl3 = styled(List)({
	backgroundColor: Colors.GREY_LIGHT_2,
	borderBottomRightRadius: '16px',
	borderTopRightRadius: '16px',
	width: "230px",
})